import {React,useEffect,useState,useReducer} from 'react'
import { Allmov } from './Fetcher'
import Singlemovie from './Singlemovie'
import Loader from '../Page/Loader'

const initalstate ={
    data:[],
    error : '',
    loading: true 
}

const reducer =(state,action)=>{
switch(action.type){
    case 'success':
    return{
        ...state,
        data : action.payload,
        error:'',
        loading : false
    }

    case 'failed':
    return{
        ...state,
        data : '',
        error:action.errormessage,
        loading : true
    }
}
}



const Allmoves = () => {
    const[allmovie, dispatch] =useReducer(reducer,initalstate)

    useEffect(()=>{
        Allmov ({dispatch})
    },[])

  
    const render=()=>{
       return allmovie.data?.map((data)=>{
        return  <Singlemovie key={data.id} data={data}/>
        })
    }
   
  return (
    <div>
        <h4 id='hot'>Marvel Movies Timeline </h4>
        {allmovie.loading ?<Loader/>:''}
  <div id='single-wrapper'>

   {allmovie.loading ?'':render()}
  {allmovie.error ?allmovie.error:''}  
  
      </div>
    </div>
  )
}

export default Allmoves